export default "/images/logo-1.png?0e05dd3157e3b46b3159d607f8f7aac3";